import { render, staticRenderFns } from "./submitDialog.vue?vue&type=template&id=108e6a40&scoped=true"
import script from "./submitDialog.vue?vue&type=script&lang=js"
export * from "./submitDialog.vue?vue&type=script&lang=js"
import style0 from "./submitDialog.vue?vue&type=style&index=0&id=108e6a40&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "108e6a40",
  null
  
)

export default component.exports